import script from "./LocationConfig.vue?vue&type=script&lang=ts"
export * from "./LocationConfig.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__